<div class="m-content" style="margin-right:1%">
  <div class="m-portlet m-portlet--tab" style="padding:1em;">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                {{userMetaData.role}} -RPL-DAP
              </h3>
          </div>
      </div>
      <div class="m-portlet__head-tools">
          <ul class="m-portlet__nav">
              <li class="m-portlet__nav-item">
                <button type="button" class="btn m-btn--pill btn-secondary" style="border-color: #ef7e22;color: #ef7e22;"
          (click)="location.back()">Back</button>
               </li>
          </ul>
      </div>
  </div>
  <div class="m-portlet__body1 form-group m-form__group row mt-3 mr-2 ml-2">
    <button (click)="selectTab(tabList?.PENDING?.value)" 
    class="col-lg-4 pt-3 pb-3 m-0 border text-center cursor-pointer font-weight-bold {{ activeTabValue === tabList?.PENDING?.value ? ' btn btn-brand' : ''}}">
      {{ tabList?.PENDING?.name }}
    </button>
    <button (click)="selectTab(tabList?.APPROVED?.value)"
     class="col-lg-4 pt-3 pb-3 m-0 border text-center cursor-pointer font-weight-bold {{ activeTabValue === tabList?.APPROVED?.value ? ' btn btn-brand' : ''}}">
      {{ tabList?.APPROVED?.name }}
    </button>
    <button (click)="selectTab(tabList?.REJECTED?.value)" 
    class="col-lg-4 pt-3 pb-3 m-0 border text-center cursor-pointer font-weight-bold {{ activeTabValue === tabList?.REJECTED?.value ? ' btn btn-brand' : ''}}">
      {{ tabList?.REJECTED?.name }}
    </button>
  </div>
    <div class="m-portlet__body1 form-group m-form__group row">
      <!-- <div class="col-6">
        <h4 class="m-portlet__head-text notranslate">
          {{userMetaData.role}} -RPL-DAP
        </h4>
      </div>
      <div class="m-demo__preview m-demo__preview--btn col-6" style="text-align: right">
        <button type="button" class="btn m-btn--pill btn-secondary" style="border-color: #ef7e22;color: #ef7e22;"
          (click)="location.back()">Back</button>
      </div> -->
      <!-- <hr> -->
      <div class="col-md-12 col-lg-12 col-sm-12">
        <div class="row" style="margin-top: 19px;">

          <div class="col-md-2">
            <label>
              <b>Type Of Assessment</b>
            </label>
            <select class="form-control selectcolor notranslate" id="m_select2_1" name="param"
              [(ngModel)]="modelObj.subschemeId">
              <option value="" disabled selected>All</option>
              <option *ngFor="let data of schemesArray" [ngValue]="data.value">{{data.name}}</option>
            </select>
          </div>

          <div class="col-md-2">
            <div class="m-input-icon m-input-icon--left row">
              <label class="search-text"><b>Search for CandidateId:</b></label>
              <input class="form-control m-input m-input--solid ng-pristine ng-valid ng-touched notranslate"
                placeholder="Search" type="text" [(ngModel)]="modelObj.candidateId" ng-reflect-name="candidateId">
              <span class="m-input-icon__icon m-input-icon__icon--left" style="top: 12px;">
                <span><i id="cus_size" class="la la-search"></i></span>
              </span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="m-input-icon m-input-icon--left row">
              <label>
                <b>Demand Type</b>
              </label>
              <div class="m-radio-inline">
                <label class="m-radio">
                    <input type="radio" name="tabValue" [(ngModel)]="tabValue" [ngModelOptions]="{standalone: true}" 
                    [value]="listRadioButtonTab?.jobRoleWise?.value">
                    {{ listRadioButtonTab?.jobRoleWise?.name }}
                    <span></span>
                </label>
                <label class="m-radio">
                    <input type="radio" name="tabValue" [(ngModel)]="tabValue"  [ngModelOptions]="{standalone: true}" 
                    [value]="listRadioButtonTab?.batchWise?.value"> 
                    {{ listRadioButtonTab?.batchWise?.name }}
                    <span></span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <label>
              <br> </label>
            <div>
              <button type="button" class="btn btn-brand" style="background:#ef7e22;color:white;"
                (click)="applyFilter()">Search</button>
              <button type="button" class="btn btn-secondary" (click)="resetFilter()">
                Reset
              </button>
            </div>
          </div>
          <br>
        </div>
        <br>
        <br>
        <div class="col-md-8" *ngIf="activeTabValue === tabList?.PENDING?.value">
          <label for="example_input_full_name">
            Selected {{count}} Candidates:</label> &nbsp;&nbsp;
          <span>
            <a class="btn btn-special" (click)="deSelectAll()">
              <span>
                <span>
                  De-Select All
                </span>
              </span>
            </a>
            <button class="btn btn-success m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
              (click)="alignBatch(true)">
              <span>
                <span>
                  Approve Candidates
                </span>
              </span>
            </button>
            <!-- <button class="btn btn-warning m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
              (click)="alignBatch(false)" *ngIf="userMetaData.role !== 'Training Partner'">
              <span>
                <span>
                  Reject Candidates
                </span>
              </span>
            </button> -->
          </span>
        </div>
      </div>
      <br>
      <div class="col-md-12">
        <div
          class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded  table-responsive text-nowrap"
          id="scrolling_horizontal" style="position: static; zoom: 1;">
          <table class="table table-bordered m-table">
            <tr>
              <th *ngIf="activeTabValue === tabList?.PENDING?.value">
                <label class="m-checkbox m-checkbox--single m-checkbox--state m-checkbox--state-success">
                  <input type="checkbox" [(ngModel)]="selectStatus" (change)="selectAll()">
                  <span></span>
                </label>
              </th>
              <th>S No</th>
              <th>Demand ID</th>
              <th>Candidate ID</th>
              <th>Sector</th>
              <th>QP Code / Job Role ID</th>
              <th>QP Name / Job Role Name</th>
              <th>State</th>
              <th>District</th>
              <th *ngIf="userMetaData.role !== 'Training Partner'">TP Name(TP ID)</th>
              <th *ngIf="userMetaData.role === 'Training Partner'">TC Name(TC ID)</th>
              <th>Demand Type</th>
              <th>Demand Duration</th>
              <th>Sub Scheme Name</th>
              <ng-container *ngIf="extraBatchFieldToShow">
                <th>Batch Id</th>
                <th>Batch Start Date</th>
                <th>Batch End Date</th>
                <th>Batch Assessment Start Date</th>
                <th>Batch Assessment End Date</th>
                <!-- <th>No of Candidate Enrolled</th> -->
                <th>Batch Status</th>
              </ng-container>
              <th>Status</th>
              <th *ngIf="activeTabValue === tabList?.PENDING?.value || (activeTabValue === tabList?.APPROVED?.value && extraBatchFieldToShow)">
                Action
              </th>
            </tr>
            <tr *ngFor="let data of candidateArray; let i = index" class="notranslate">
              <td *ngIf="activeTabValue === tabList?.PENDING?.value">
                <label class="m-checkbox m-checkbox--single m-checkbox--state m-checkbox--state-success">
                  <input type="checkbox" [(ngModel)]="data.checked" value="{{candidateArray.checked}}"
                    (change)="checkIfAllSelected($event);">
                  <span></span>
                </label>
              </td>
              <td>{{ getSn(i) }}</td>
              <td>{{ data?.demandId }}</td>
              <td>{{data?.candidateId ? data?.candidateId: ''}}</td>
              <td>
                {{data?.sector?.name? data.sector.name:''}}
              </td>
              <td>
                {{data?.jobRole?.qpCode? data.jobRole.qpCode:''}}
              </td>
              <td>
                {{data?.jobRole?.name? data.jobRole.name:''}}
              </td>
              <td>
                {{data?.address?.state?.name? data.address.state.name:''}}
              </td>
              <td>
                {{data?.address?.district?.name? data.address.district.name:''}}
              </td>
              <td *ngIf="userMetaData.role !== 'Training Partner'">
                {{data?.trainingPartner?.name? data.trainingPartner.name:''}} ({{data?.trainingPartner?.userName?
                data.trainingPartner.userName:''}})
              </td>
              <td *ngIf="userMetaData.role === 'Training Partner'">
                {{data?.trainingCentreName? data.trainingCentreName:''}} ({{data?.tcId? data.tcId: ''}})
              </td>
              <td> {{(demand_type === listRadioButtonTab?.batchWise?.value ? listRadioButtonTab?.batchWise?.name : listRadioButtonTab?.jobRoleWise?.name)}}</td>
              <td>
                {{data?.demandDuration && data?.demandDuration?.from  ? (data?.demandDuration?.from | date:'d MMM, y') : '' }} -
                {{data?.demandDuration && data?.demandDuration?.to  ? (data?.demandDuration?.to | date:'d MMM, y') : '' }}
              </td>
              <td>
                {{data?.subschemeName? data.subschemeName : ''}}
              </td>
              <ng-container *ngIf="extraBatchFieldToShow">
                <td>{{ data?.batch?.batchId }}</td>
                <td>{{ data?.batch?.batchStartDate | date: 'dd-MMM-yyyy'}}</td>
                <td>{{ data?.batch?.batchEndDate | date: 'dd-MMM-yyyy'}}</td>
                <td>{{ data?.batch?.assessmentStartDate | date: 'dd-MMM-yyyy'}}</td>
                <td>{{ data?.batch?.assessmentEndDate | date: 'dd-MMM-yyyy'}}</td>
                <!-- <td>No of Candidate Enrolled</td> -->
                <td> {{ data?.batch?.Batch_status }} </td>
              </ng-container>
              <td>
                <span class="m-badge m-badge--brand m-badge--wide status-btn"
                  [style.background-color]="statusColor[data.demandStatus? data.demandStatus :'Pending']">{{data.demandStatus? data.demandStatus:'Pending'}} By {{data.lastActionTaken?.role ? data.lastActionTaken.role: ''}}
                </span>
              </td>
              <td *ngIf="activeTabValue === tabList?.PENDING?.value || (activeTabValue === tabList?.APPROVED?.value && extraBatchFieldToShow)">
                <div class="dropdown dropup">
                  <a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
                    data-toggle="dropdown" aria-expanded="false">
                    <i class="la la-ellipsis-h"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right" x-placement="top-end"
                    style="position: absolute; transform: translate3d(-132px, -143px, 0px); top: 0px; left: 0px; will-change: transform;">
                    <a *ngIf="activeTabValue === tabList?.PENDING?.value" class="dropdown-item" (click)="alignindividual(data, 'Approved')">Approve
                      Candidate</a>
                    <a *ngIf="activeTabValue === tabList?.PENDING?.value" class="dropdown-item" (click)="alignindividual(data, 'Rejected')">Reject
                      Candidate</a>
                    <a *ngIf="activeTabValue === tabList?.APPROVED?.value && extraBatchFieldToShow" class="dropdown-item" (click)="enrollmentCheck(data)">Enroll
                      Candidate</a>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="candidateArray?.length === 0" style="color:grey;font-size:17px">
              <td *ngIf="!extraBatchFieldToShow" colspan="12">
                <p style="text-align:center;">No Candidates Found For Respective User</p>
              </td>
              <td *ngIf="extraBatchFieldToShow" colspan="18">
                <p style="text-align:center;">No Candidates Found For Respective User</p>
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="length>9">
          <app-pagination [count]=length (pageNumber)="assignPageNo($event)"
            (recordsPerPage)="assignRecordsPerPage($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="IdOrAdharFailCandidatesModal" tabindex="-1" role="dialog"
        aria-labelledby="confirmationBoz">
        <div class="modal-dialog" role="document">
            <div class="modal-content" style="width: 813px;margin-left: -190px;">
              <div class="modal-header notranslate">
                <h5 class="modal-title" id="exampleModalLabel">Failed Reason</h5>
                <button type="button" class="close" (click)="closeCandidateErrorModal()" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
                <div class="modal-header">
                    Enrollment Failure
                </div>
                <div class="modal-body" style="height: 662px;overflow-y: scroll;padding: 28px;">
                    <div>
                        <h3 style="text-align:center;color:red;">Failed To Enroll Candidate</h3>
                        <br>
                        <span>

                        </span>
                        <br><br>
                        <!-- Aaadhar or alternate one is required -->
                        <span *ngIf="NoAdharNoAltIdCandidatesCheck?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Alternate ID Or Aadhaar Not Found For Below Candidates</label> &nbsp;&nbsp;

                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate Name</strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <!-- <th>
                                            <strong>Action</strong>
                                        </th> -->
                                        <!-- commented by ankit -->
                                        <!-- <th>
                                    <strong>Action</strong>
                                </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of NoAdharNoAltIdCandidatesCheck, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.firstName?candidate.firstName: 'N/A'}}</td>
                                        <td>{{candidate.candidateID}}</td>
                                        <!-- <td>
                                            <span style="color: blue;font-weight: bold;cursor: pointer;" (click)="actionOpenModal('aadhar', candidate)">Update Aadhaar</span>
                                            <span style="color: black;cursor:initial;">or</span>
                                            <span style="color: blue;font-weight: bold;cursor: pointer;" (click)="actionOpenModal('alternate', candidate)">Update Alternate ID</span>
                                </td> -->
                                    </tr>
                                </table>
                            </div>
                        </span>
                        <!-- end -->
                        <span *ngIf="AdharOrBankDetailNotTherCheck?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Aadhaar Or Bank Details Not Found In Below Candidate</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                S.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate with reason</strong>
                                        </th>
                                        <!-- <th>
                                    <strong>Candidate Name</strong>
                                </th>
                                <th>
                                    <strong>Action</strong>
                                </th> -->
                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of AdharOrBankDetailNotTherCheck, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate}}</td>
                                        <!-- <td>{{i+1}}</td>
                                   <td>{{candidate.userName}}</td>
                                   <td>{{candidate.firstName}}</td>
                                   <td style="color: blue;font-weight: bold;cursor: pointer;" (click)="openBankDetailsModal(candidate)">Update Bank Details</td> -->


                                    </tr>
                                </table>
                            </div>
                        </span>

                        <span *ngIf="disabilityDocErrorCheck?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Disability Document Not Found For Below Candidate</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate Name</strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <th>
                                            <strong>Action</strong>
                                        </th>
                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of disabilityDocErrorCheck, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.firstName?candidate.firstName: 'N/A'}}</td>
                                        <td>{{candidate.candidateID}}</td>
                                        <!-- <td style="color: blue;font-weight: bold;cursor: pointer;"
                                            (click)="actionOpenModal('disability', candidate)">Upload Disability
                                            Document</td> -->
                                        <!-- <td>Upload Disability Document</td> -->
                                    </tr>
                                </table>
                            </div>
                        </span>
                        <span *ngIf="IdOrAdharFailCandidates?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Alternate ID Or Aadhaar Verification Failed Candidate Below</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate Name</strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <!-- <th>
                                            <strong>Action</strong>
                                        </th> -->
                                        <!-- commented by ankit -->
                                        <!-- <th>
								   <strong>Action</strong>
							   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of IdOrAdharFailCandidates, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.firstName?candidate.firstName: 'N/A'}}</td>
                                        <td>{{candidate.candidateID}}</td>
                                        <!-- <td><span
                                                style="color: blue;font-weight: bold;cursor: pointer;"
                                                (click)="actionOpenModal('aadhar', candidate)">Update Aadhaar</span> or
                                            <span style="color: blue;font-weight: bold;cursor: pointer;"
                                                (click)="actionOpenModal('alternate', candidate)">Update Alternate
                                                ID</span></td> -->
                                    </tr>
                                </table>
                            </div>
                        </span>
                        <hr>
                        <span *ngIf="AdharFailCandidates?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Aadhaar Verification Failed Candidate Below</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <!-- <th>
                                            <strong>Action</strong>
                                        </th> -->
                                        <!-- commented by ankit -->
                                        <!-- <th>
							   <strong>Action</strong>
						   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of AdharFailCandidates, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate?.userName}}</td>
                                        <!-- <td style="color: blue;font-weight: bold;cursor: pointer;"
                                            (click)="actionOpenModal('aadhar', candidate)">Update Aadhaar</td> -->
                                        <!-- <td >Update Aadhar</td> -->

                                    </tr>
                                </table>
                            </div>
                        </span>
                        <!-- photo failed -->
                        <span *ngIf="profilePictureRequired?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Profile Photo Required For Below Candidate</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <!-- <th>
                                            <strong>Action</strong>
                                        </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of profilePictureRequired, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.candidateID}}</td>
                                        <!-- <td style="color: blue;font-weight: bold;cursor: pointer;"
                                            (click)="actionOpenModal('profilePicture', candidate)">Update Profile
                                            Picture</td> -->
                                        <!-- <td >Update Profile Picture</td> -->

                                    </tr>
                                </table>
                            </div>
                        </span>


                        <!-- voter & pan failed -->
                        <span *ngIf="failedCandidateForVoterPan?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Please upload PAN CARD/VOTER ID for below candidates</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <!-- <th>
                                            <strong>Action</strong>
                                        </th> -->
                                        <!-- commented by ankit -->
                                        <!-- <th>
                                   <strong>Action</strong>
                               </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of failedCandidateForVoterPan, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.candidateID}}</td>
                                        <!-- <td style="color: blue;font-weight: bold;cursor: pointer;"
                                        (click)="actionOpenModal('panVoterId', candidate)">Please Update PAN Card/Voter ID</td> -->
                                    </tr>
                                </table>
                            </div>
                        </span>

                        <!-- DUe to old can chec -->
                        <span *ngIf="EnrollCheckForOldData?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Enrollment Failure For Below Candidates</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidates</strong>
                                        </th>

                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of EnrollCheckForOldData, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate}}</td>
                                    </tr>
                                </table>
                            </div>
                        </span>
                        <!-- Trained for same qp can -->
                        <span *ngIf="trainedForSameQpBucket?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Cannot Enroll Below Candidate <br><b style="color:black;">Already Trained For Same
                                        QP <span style="color:green;">{{selectedTc?.jobRole?.name}} ({{selectedTc?.jobRole?.qpCode}})</span></b></label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate Name</strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>

                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of trainedForSameQpBucket, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.firstName?candidate.firstName: 'N/A'}}</td>
                                        <td>{{candidate.userName}}</td>
                                    </tr>
                                </table>
                            </div>
                        </span>
                        <!-- already done in other batch check -->
                        <span *ngIf="EnrolledOtherBatchInPastSixMonthBucket?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    The following candidates cannot be enrolled since they have already enrolled in
                                    another batch in the past six months.
                                </label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate Name</strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>

                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr
                                        *ngFor="let candidate of EnrolledOtherBatchInPastSixMonthBucket, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.firstName?candidate.firstName: 'N/A'}}</td>
                                        <td>{{candidate.userName}}</td>
                                    </tr>
                                </table>
                            </div>
                        </span>
                        <!-- SP RULE CHECK -->
                        <span *ngIf="SpRulesErrMsgsBucket?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    SP Rule Check</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate With Reason</strong>
                                        </th>


                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of SpRulesErrMsgsBucket, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate}}</td>

                                    </tr>
                                </table>
                            </div>
                        </span>

                        <span *ngIf="PWDJobRoleErrMsgsCheck?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Non PwD candidates cannot be enrolled in this batch</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate With Reason</strong>
                                        </th>


                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of PWDJobRoleErrMsgsCheck, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate}}</td>

                                    </tr>
                                </table>
                            </div>
                        </span>

                        <!-- More than two jobrole check -->
                        <span *ngIf="enrollFailDueToEnrolCntBucket?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Candidate has already enrolled for PMKVY scheme twice.<br>
                                    Further enrollment to PMKVY scheme is not allowed.
                                </label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <th>
                                            <strong>Candidate Name</strong>
                                        </th>


                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of enrollFailDueToEnrolCntBucket, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.userName}}</td>
                                        <td>{{candidate.firstName?candidate.firstName: 'N/A'}}</td>
                                    </tr>
                                </table>
                            </div>
                        </span>

                        <!-- RPL RULE CHECK -->
                        <span *ngIf="RplRulesErrMsgsCheck?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    RPL Rule Check
                                </label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate With Reason</strong>
                                        </th>
                                        <!-- commented by ankit -->
                                        <!-- <th>
                                       <strong>Action</strong>
                                   </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of RplRulesErrMsgsCheck, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate}}</td>
                                    </tr>
                                </table>
                            </div>
                        </span>
                        <!-- END OF RPL CHECK -->
						<!-- DUe to Moma check -->
						<span *ngIf="ageNotEligibleCandidateCheck?.length > 0 && isSchemeMoma">
							<div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
								id="scrolling_horizontal" style="position: static; zoom: 1;">
								<label style="color:red;" for="example_input_full_name">
									Enrollment Failure For Below Candidates due to Age Restriction
								</label> &nbsp;&nbsp;
								<table class="table table-striped">
									<tr>
										<th>
											<strong>
												Sl.No
											</strong>
										</th>
										<th>
											<strong>Candidates</strong>
										</th>

										<!-- commented by ankit -->
										<!-- <th>
									<strong>Action</strong>
								</th> -->
									</tr>
									<tr *ngFor="let candidate of ageNotEligibleCandidateCheck, let i = index;">
										<td>{{i+1}}</td>
										<td>{{candidate}}</td>
									</tr>
								</table>
							</div>
						</span>

						<span *ngIf="religionNotEligibleCandidate?.length > 0 && isSchemeMoma">
							<div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
								id="scrolling_horizontal" style="position: static; zoom: 1;">
								<label style="color:red;" for="example_input_full_name">
									Enrollment Failure For Below Candidates due to Religion Restriction
								</label> &nbsp;&nbsp;
								<table class="table table-striped">
									<tr>
										<th>
											<strong>
												Sl.No
											</strong>
										</th>
										<th>
											<strong>Candidates</strong>
										</th>

										<!-- commented by ankit -->
										<!-- <th>
									<strong>Action</strong>
								</th> -->
									</tr>
									<tr *ngFor="let candidate of religionNotEligibleCandidate, let i = index;">
										<td>{{i+1}}</td>
										<td>{{candidate}}</td>
									</tr>
								</table>
							</div>
						</span>
                        

                        <!-- Sankalp tehsil or Block check -->
                        <span *ngIf="BlockNameNotThereCandidate && BlockNameNotThereCandidate?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                   Block Address is Required For Below Candidate</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <!-- <th>
                                            <strong>Action</strong>
                                        </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of BlockNameNotThereCandidate, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.candidateID}}</td>
                                        <!-- <td style="color: blue;font-weight: bold;cursor: pointer;"
                                            (click)="actionOpenModal(sankalpModalIds.sankalp_block_id, candidate)">Update Block/Tehsil</td> -->
                                        <!-- <td >Update Profile Picture</td> -->

                                    </tr>
                                </table>
                            </div>
                        </span>
                        <!-- Sankalp tehsil or Block check -->

                        <!-- Gram Panchayat check -->
                        <span *ngIf="GramPanchayatNotThereCandidate && GramPanchayatNotThereCandidate?.length > 0">
                            <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded"
                                id="scrolling_horizontal" style="position: static; zoom: 1;">
                                <label style="color:red;" for="example_input_full_name">
                                    Gram Panchayat is Required For Below Candidate</label> &nbsp;&nbsp;
                                <table class="table table-striped">
                                    <tr>
                                        <th>
                                            <strong>
                                                Sl.No
                                            </strong>
                                        </th>
                                        <th>
                                            <strong>Candidate ID</strong>
                                        </th>
                                        <!-- <th>
                                            <strong>Action</strong>
                                        </th> -->
                                    </tr>
                                    <tr *ngFor="let candidate of GramPanchayatNotThereCandidate, let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{candidate.candidateID}}</td>
                                        <!-- <td style="color: blue;font-weight: bold;cursor: pointer;"
                                            (click)="actionOpenModal(sankalpModalIds.sankalp_block_id, candidate)">Update Gram Panchayat</td> -->
                                        <!-- <td >Update Profile Picture</td> -->

                                    </tr>
                                </table>
                            </div>
                        </span>
                        <!-- Gram Panchayat check -->

                        <p class="modal-btn">
                            <!-- <button type="button" class="btn close-btn center-btn" #closeModal data-dismiss="modal">Close</button> -->
                            <!-- <button type="button" class="btn btn-primary center-btn btn-create" (click)="actionFunction('download')">Download Submitted Form</button> -->
                            <!-- <button type="button" class="btn btn-primary center-btn btn-create" *ngIf="isValidForCheckEnroll()" [disabled]="validEnroll()" (click)="enrollCan('closeModal')">Enroll Candidate</button> -->
                            <button type="button" class="btn btn-primary center-btn btn-create"
                                (click)="closeCandidateErrorModal()">Close</button>
                            <!-- <button type="button" class="btn btn-primary center-btn btn-create" (click)="actionFunction('view')">View and Download</button> -->

                        </p>

                        <p class="demo-profile-btn">
                            <!-- <button type="button" class="btn m-btn--pill    btn-outline-danger m-btn m-btn--outline-2x " (click)="actionFunction('demo')">Demo to Profile</button> -->
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>